import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, Legend, PieChart, Pie, Cell } from "recharts";

const COLORS = ["#2563EB", "#F59E0B", "#EF4444", "#10B981"];

export default function Reports() {
  const [rows, setRows] = useState([]);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/reports/productivity").then(({ data }) => setRows(data));
    api.get("/dashboard/stats").then(({ data }) => setStats(data));
  }, []);

  const deptData = stats ? Object.entries(stats.department_pending).map(([k, v]) => ({ name: k, value: v })) : [];

  return (
    <div className="space-y-5" data-testid="reports-page">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Analytics</div>
        <h1 className="font-display text-3xl font-bold tracking-tight mt-1">Reports</h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card className="p-5">
          <h3 className="font-display font-semibold mb-4">Employee productivity</h3>
          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={rows}>
              <XAxis dataKey="name" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="completed" stackId="a" fill="#10B981" />
              <Bar dataKey="in_progress" stackId="a" fill="#2563EB" />
              <Bar dataKey="pending" stackId="a" fill="#F59E0B" />
            </BarChart>
          </ResponsiveContainer>
        </Card>

        <Card className="p-5">
          <h3 className="font-display font-semibold mb-4">Department distribution</h3>
          <ResponsiveContainer width="100%" height={320}>
            <PieChart>
              <Pie data={deptData} dataKey="value" nameKey="name" outerRadius={100} label>
                {deptData.map((entry, i) => <Cell key={entry.name} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: 12 }} />
            </PieChart>
          </ResponsiveContainer>
        </Card>
      </div>

      <Card className="p-5">
        <h3 className="font-display font-semibold mb-3">Team detail</h3>
        <div className="divide-y divide-border">
          {rows.map(r => (
            <div key={r.name} className="grid grid-cols-5 py-3 text-sm">
              <div className="font-medium">{r.name}</div>
              <div className="text-center font-mono tabular-nums">{r.total}</div>
              <div className="text-center font-mono tabular-nums text-emerald-600">{r.completed}</div>
              <div className="text-center font-mono tabular-nums text-blue-600">{r.in_progress}</div>
              <div className="text-center font-mono tabular-nums text-amber-600">{r.pending}</div>
            </div>
          ))}
          {rows.length === 0 && <div className="py-6 text-center text-sm text-muted-foreground">No data.</div>}
        </div>
      </Card>
    </div>
  );
}
